import { Chip } from '@mui/material';
import styled from 'styled-components';
export const MigratedChip = styled(Chip) `
  && {
    padding: 0.5rem;
    margin-left: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }
`;
